// Sprint 3 (2026-05-17): clasifica el sub-estado de una vaca en producción
// para mostrar badges en UI. Decisión: NO se crean sub-cuentas contables, la
// distinción es operativa via badges visuales (decisions-log.md 2026-05-17).
//
// Lógica:
//   - Lactando: is_lactating = true (independiente de dry_off).
//   - Seca:     is_lactating = false AND días_al_próximo_parto > 30.
//   - Pronta:   is_lactating = false AND días_al_próximo_parto <= 30.
//   - null:     no aplica (animal no productivo, sin dry_off registrado, etc.)
//
// días_al_próximo_parto = (lastDryOffAt + 280 días) - hoy.
// Si lastDryOffAt es null, la estimación no es posible — devolvemos null y la
// UI no muestra badge.

const BOVINE_GESTATION_DAYS = 280;

export type ProducingSubState = "lactando" | "seca" | "pronta";

export type AnimalForSubState = {
  lifecycleState: string;
  isLactating: boolean;
  lastDryOffAt?: string | null;
};

function daysToNextCalving(lastDryOffAt: string, now: Date): number {
  const dryOffMs = new Date(`${lastDryOffAt}T00:00:00Z`).getTime();
  const expectedCalvingMs = dryOffMs + BOVINE_GESTATION_DAYS * 24 * 60 * 60 * 1000;
  const diffMs = expectedCalvingMs - now.getTime();
  return Math.floor(diffMs / (24 * 60 * 60 * 1000));
}

export function producingSubState(
  animal: AnimalForSubState,
  now: Date = new Date(),
): ProducingSubState | null {
  if (animal.lifecycleState !== "cow_producing") return null;
  if (animal.isLactating) return "lactando";
  if (!animal.lastDryOffAt) {
    // No sabemos cuánto falta. UI omite badge en lugar de mostrar default
    // potencialmente engañoso.
    return null;
  }
  const days = daysToNextCalving(animal.lastDryOffAt, now);
  if (days > 30) return "seca";
  return "pronta";
}

export const SUB_STATE_LABEL: Record<ProducingSubState, string> = {
  lactando: "Lactando",
  seca: "Seca",
  pronta: "Pronta",
};
